import ClientSuspense from '@components/ClientSuspense'
import {StorePublicOptions} from '@data/queries/reservations/getReservationsStorePublicOptions.reservations'

import Layout from '../Layout'
import Logo from '../Logo'

import OtherData from './OtherData'
import PersonalInformation from './PersonalInformation'
import {ReservationContext, useCreateTheCreateReservationContext} from './ReservationContext'
import Resume from './Resume'
import SelectDate from './SelectDate'
import ReservePartySize from './SelectDate/PartySize'
import SelectDateSkeleton from './SelectDate/Skeleton'
import Submit from './Submit'

export interface Props {
  storeOptions: StorePublicOptions
  isWaitingList?: boolean
}

export default function CreateReservationFromStore(props: Props) {
  const {storeOptions, isWaitingList} = props
  const contextValue = useCreateTheCreateReservationContext(storeOptions, isWaitingList)

  if (isWaitingList) {
    return (
      <ReservationContext.Provider value={contextValue}>
        <Layout>
          <Logo />
          <div className="space-y-5">
            <PersonalInformation />
            <ReservePartySize />
            <OtherData />
            <Resume />
            <Submit />
          </div>
        </Layout>
      </ReservationContext.Provider>
    )
  }
  return (
    <ReservationContext.Provider value={contextValue}>
      <Layout
        sidebar={
          <div className="space-y-5">
            <PersonalInformation />
            <OtherData />
            <Resume />
            <Submit />
          </div>
        }
      >
        <Logo />
        <ClientSuspense fallback={<SelectDateSkeleton />}>
          <SelectDate />
        </ClientSuspense>
      </Layout>
    </ReservationContext.Provider>
  )
}
